import React from 'react';
import { Col } from '@amzn/atoz-web/Col';
import { VTOAvailableCard } from './VTOAvailableCard';
export var VTOAvailable = function (_a) {
    var vtoOpportunities = _a.vtoOpportunities, setModalContent = _a.setModalContent, setModalError = _a.setModalError;
    if (!setModalContent || !setModalError || vtoOpportunities.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Col, { dataTestId: "VTOAvailable", gridGap: "S200" }, vtoOpportunities.map(function (vtoOpportunity, i) { return (React.createElement(VTOAvailableCard, { key: "VTOAvailable-".concat(i), vtoOpportunity: vtoOpportunity, setModalContent: setModalContent, setModalError: setModalError })); })));
};
